export default function (token) {
  try {
    const base64URL = token.split('.')[1];
    const base64 = base64URL.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  } catch (error) {
    return null;
  }
}
